import maptunDefaults, { createPriceFormatter } from '../3togqybnuz-1/config.js';
import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

const categoryListPages = [
  '/c/moottoripyorat/',
  '/c/veneet/',
  '/c/autot/',
  '/c/vesijetit/',
  '/c/atv/',
  '/c/utv/',
  '/c/moottorikelkat/',
];
const categoryListSubcategoriesCount = 5;

const isCategoryListPage = categoryListPages.includes(window.location.pathname);

const categoryPageWidget = bigcommerceGenericDefaults.Widgets.find((w) => w.name === 'CategoryPage');

function facetResponseHandler(response) {
  const facet = isCategoryListPage && response.Facets.find((f) => f.FieldName === 'category');

  if (facet) {
    const { TreeSeparator: separator, Values: values } = facet;

    facet.Values = values
      .filter((v) => v.TreeLevel === 0)
      .flatMap((category) => {
        const pagePath = category.Term.slice(0, category.Term.lastIndexOf(separator) + 1);
        const subcategories = values
          .filter((v) => v.TreeLevel === 1 && v.Term.startsWith(`${category.Term}${separator}`))
          .slice(0, categoryListSubcategoriesCount);

        return [category, ...subcategories].map((v) => ({ ...v, Term: v.Term.slice(pagePath.length) }));
      });
  }

  return response;
}

export default {
  ...maptunDefaults,
  includes: ['bigcommerce-generic', '3togqybnuz-1'],
  facetResponseHandler,
  product: {
    formatPrice: createPriceFormatter('fi-FI'),
  },
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'CategoryPage',
          'HeaderVehicleWidget',
          'SearchVehicleWidget',
          'CategoryPageCategoriesGrid',
          'FacetDialog',
        ].includes(w.name),
    ),
    {
      ...categoryPageWidget,
      visibleIf: () => categoryPageWidget.visibleIf() && !isCategoryListPage,
    },
    {
      ...bigcommerceGenericDefaults.Widgets.find((w) => w.name === 'FacetDialog'),
      initCollapsed: false,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm-ymm',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      initCollapsed: true,
      isAlwaysActive: false,
      columnBreakpoint: 650,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters &&
        bigcommerceGenericDefaults.fitmentSearch.baseFields,
      isVehicleSelectionIsolated: !!window.Convermax.config?.isVehicleSelectionIsolated,
      visibleIf: () =>
        (window.location.pathname.includes('/c/') || window.location.pathname.includes('/search')) &&
        !isCategoryListPage,
    },
    {
      name: 'CategoryPageCategoriesGrid',
      type: 'FacetTiles',
      location: '#cm-categories-grid-list',
      template: 'facetTiles/subtitles',
      view: 'grid',
      facetField: 'category',
      visibleIf: () => window.location.pathname !== '/categories/' && !isCategoryListPage,
    },
    {
      name: 'CategoryPageCategoryList',
      type: 'FacetTiles',
      location: '#cm-categories-grid-list',
      template: 'facetTiles/hierarchicalList',
      facetField: 'category',
      isMultiLevel: true,
      isVehicleWidgetDisabled: true,
      visibleIf: () => isCategoryListPage,
    },
  ],
};
